/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class ApiConfiguration {
  rootUrl: string = '/ai-proxy-api/user';
}

/**
 * Parameters for `AiProxyApiModule.forRoot()`
 */
export interface ApiConfigurationParams {
  rootUrl?: string;
}
